var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platforma_ALL",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL---2---Dashboard",
    transform: "translate(-254.000000, -474.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(240.000000, 457.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph.1-copy",
    transform: "translate(14.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 6,
    width: 4,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 12,
    y: 0,
    width: 4,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 12,
    width: 4,
    height: 8
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnGraph);
export default __webpack_public_path__ + "static/media/columnGraph.563748fd08f997afbbd7d2d1ca0e662d.svg";
export { ForwardRef as ReactComponent };